<div class="mapa-header-container">
    <div [ngClass]="{'handset' : (isHandset$ | async)}">
        <div class="mapa-identificacao-ministerio">
            <a class="mapa-brasil-gov" href="http://www.brasil.gov.br"
               target="_blank">{{ 'CORE.HEADER.MINISTERIO' | translate }}</a>
            <span *ngIf="ambiente" class="mapa-ambiente">{{ambiente}}</span>
        </div>
        <div class="mapa-identificacao-sistema-container">
            <div class="mapa-identificacao-sistema">
                <h1>
                    <a id="link-pagina-inicial" [title]="'CORE.HEADER.HOME_TITLE' | translate" [routerLink]="baseApp">
                        {{aplicacao ? aplicacao.nome : ''}}&nbsp;

                    </a>
                </h1>
                <h2>
                    {{aplicacao ? aplicacao.versao : ''}} - {{aplicacao ? aplicacao.objetivo : ''}}&nbsp;
                </h2>
            </div>
            <div *ngIf="usuario && usuario.nome" class="mapa-dados-login-container">
                <div class="mapa-dados-login">
                    <ngx-avatar [name]="usuario.nome" initialsSize="2"></ngx-avatar>
                    <span class="mapa-dados-login-val">{{usuario.nome}}</span>
                </div>
                <div class="mapa-dados-login-imagem">

                </div>
            </div>
        </div>
    </div>
    <mapa-nav-bar></mapa-nav-bar>
    <mapa-breadcrumb></mapa-breadcrumb>
</div>
<div class="mapa-page-header" *ngIf="pageTitle!=undefined && pageTitle!=null">
    <h3>{{pageTitle}}</h3>
</div>
